import AdminRoutes from '@config/routes/admin';
import { IRoute } from '@config/routes/interfaces';
import LoginRoutes from '@config/routes/login';
import PrivateRoutes from '@config/routes/private';
import PublicRoutes from '@config/routes/public';

const combinedRoutes = [...AdminRoutes, ...PrivateRoutes, ...LoginRoutes, ...PublicRoutes];

export const AllRoutes = {
    path: (key: string, params?: any) => {
        const route = combinedRoutes.find((r: IRoute) => r.key === key);

        if (route) {
            if (!params) return route.path;

            let { path } = route;
            Object.keys(params).forEach((k: string) => {
                path = path?.replace(`:${k}`, (params[k] || '').toString());
            });

            return path;
        }
        return null;
    },
    key: (route: string) => {
        return combinedRoutes.find((r: IRoute) => r.path === route)?.key;
    },
    pageToolbarComponents: (key: string) => {
        return combinedRoutes.find((r: IRoute) => r.key === key)?.pageToolbarComponents;
    },
    isKeyCentralMonitoringToolkit: (key: string) => {
        const route = combinedRoutes.find((r: IRoute) => r.key === key);
        return route?.isCentralMonitoringToolkitEnabled;
    },
    isKeySubjectMonitoringToolkit: (key: string) => {
        const route = combinedRoutes.find((r: IRoute) => r.key === key);
        return route?.isSubjectMonitoringToolkitEnabled;
    },
    isKeyRiskAssessmentToolkit: (key: string) => {
        const route = combinedRoutes.find((r: IRoute) => r.key === key);
        return route?.isRiskAssessmentToolkitEnabled;
    },
};
